The upper limit of webhook subscriptions to return from the end of the list.

Excess webhook subscriptions will be trimmed from the start of the list.

`first` and `last` cannot be specified in the same query.
